<template>
  <v-card flat class="mx-auto px-0 py-0">
    <v-card-title class="pb-0">
      <h5>CRITERIOS DE BÚSQUEDA</h5>
      <v-spacer></v-spacer>
      <v-btn
        v-if="vercriterios == true && verocultar"
        icon
        color="primary"
        title="Ocultar Criterios"
        @click="vercriterios = !vercriterios"
      >
        <v-icon>mdi-eye-off-outline</v-icon>
      </v-btn>
      <v-btn
        v-if="vercriterios == false && verocultar"
        color="primary"
        icon
        title="Mostrar Criterios"
        @click="vercriterios = !vercriterios"
      >
        <v-icon>mdi-eye-outline</v-icon>
      </v-btn>
      <!-- <v-btn
        large
        color="primary"
        icon
        title="Agregar Criterio de Búsqueda"
        @click="agregarCriterio"
      >
        <v-icon>mdi-filter-plus</v-icon>
      </v-btn> -->
      <v-btn large icon title="Buscar" color="primary" @click="buscar">
        <v-icon>mdi-magnify</v-icon>
      </v-btn>
      <v-btn
        large
        icon
        color="primary"
        title="Agregar nuevo registro"
        @click="modalAdd"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-card-title>
    <ValidationObserver ref="criterios_form">
      <v-card-text v-if="vercriterios">
        <div v-for="criterio in criterios" :key="criterio.id">
          <v-row class="px-5 my-0 py-0">
            <v-col class="py-0" cols="12" sm="4" md="4">
              <ValidationProvider name="Buscar" rules="required">
                <v-select
                  v-model="criterio.campo"
                  :items="campos"
                  slot-scope="{ errors, valid }"
                  :error-messages="errors"
                  :success="valid"
                  item-text="etiqueta"
                  item-value="campo"
                  label="Campo Buscar"
                  required
                  icon=""
                ></v-select>
              </ValidationProvider>
            </v-col>
            <v-col class="py-0" cols="12" sm="3" md="3">
              <ValidationProvider name="Operador" rules="required">
                <v-select
                  v-model="criterio.operador"
                  :items="operadores"
                  item-text="nombre"
                  item-value="id"
                  label="Operador"
                  slot-scope="{ errors, valid }"
                  :error-messages="errors"
                  :success="valid"
                  required
                  icon=""
                ></v-select>
              </ValidationProvider>
            </v-col>
            <v-col class="py-0" cols="12" sm="4" md="4">
              <ValidationProvider name="Valor" rules="required">
                <v-text-field
                  v-model="criterio.valor"
                  label="Valor"
                  slot-scope="{ errors, valid }"
                  :error-messages="errors"
                  :success="valid"
                  required
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <!-- <v-col class="py-0" cols="12" sm="1" md="1">
              <v-btn
                large
                icon
                title="Eliminar Criterio"
                @click="eliminarCriterio(criterio.id)"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col> -->
          </v-row>
        </div>
      </v-card-text>
    </ValidationObserver>
  </v-card>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Filtros",
  data: () => ({
    vercriterios: false,
    criterios: [],
    operadores: [
      { id: "==", nombre: "Igual a" },
      { id: "!=", nombre: "Diferente a" },
      { id: "<", nombre: "Menor que" },
      { id: "<=", nombre: "Menor o Igual que" },
      { id: ">", nombre: "Mayor que" },
      { id: ">=", nombre: "Mayor o Igual que" },
      //   { id: "in", nombre: "Se encuentra en" },
      //   { id: "not-in", nombre: "No se encuentra en" },
    ],
  }),
  props: {
    campos: { type: Array },
    verocultar: { type: Boolean, default: true },
  },
  mounted() {
    this.agregarCriterio();
  },
  methods: {
    async enviarCriterios() {
      const result = await this.$refs.criterios_form.validate();
      if (!result) return false;
      return this.criterios;
    },
    async buscar() {
      this.$emit("actualizarFiltro");
    },
    async modalAdd() {
      this.$emit("nuevo");
    },
    eliminarCriterio(strid) {
      const index = this.criterios.map((e) => e.id).indexOf(strid);
      this.criterios.splice(index, 1);
    },
    async agregarCriterio() {
      const id = parseInt(Date.now() + (Math.random() * (1000 - 99) + 99));
      this.criterios.push({ id: id, campo: "", operador: "==", valor: "" });
    },
  },
};
</script>

<style></style>
